import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { User } from '../models/user.model';
import { AuthService } from '../services/auth.service';

@Directive({
    selector: '[shownForRoles]',
    standalone: false
})
export class ShownForRolesDirective implements OnInit {

    private roles: string[];
    private user: User;

    constructor(private templateRef: TemplateRef<any>,
                private viewContainer: ViewContainerRef,
                private authService: AuthService) {
    }

    @Input() set shownForRoles(roles: string[]) {
        this.roles = roles;
        this.refresh();
    }

    ngOnInit(): void {
        this.getUser();
    }

    private getUser(): void {
        this.user = this.authService.getUser();
    }

    private refresh(): void {
        this.hide();
        this.getUser();
        if (this.user && this.roles
            && (this.user.roles.includes('ADMIN')
                || this.user.roles.some(role => this.roles.includes(role)))) {
            this.show();
        }
    }

    private show(): void {
        this.viewContainer.createEmbeddedView(this.templateRef);
    }

    private hide(): void {
        this.viewContainer.clear();
    }
}
